import cookie from "js-cookie";

export const setCookie = (key, value) => {
  
    cookie.set(key, value, {
      expires: 1,
      path: "/",
    });
  
};

export const getCookie = (key, value) => {
  return cookie.get(key);
};

export const removeCookie = (key) => {
  
    cookie.remove(key, {
      expires: 1,
    });
  
};